import React from 'react';
import { useTranslation } from 'react-i18next';
import './MissionPage.css'; // Importazione del file CSS specifico


function MissionPage() {
    const { t } = useTranslation();
  return (
      <div>
          <article className="ArticleMainContent layout-content-container flex flex-col  flex-1" >
              <div className="p-4">
          <section className="article-header text-center lg:py-10" >
              <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-6xl font-bold leading-tight">
                    {t('missionPage.title')}
                </h1>
              </div>
          </section>
                  <div style={{marginTop: "1em"}} className="max-w-4xl mx-auto text-lg leading-relaxed text-gray-700">
                      <h2 className="text-2xl font-semibold mb-4">{t('missionPage.ourVisionTitle')}</h2>
                      <p className="mt-4" dangerouslySetInnerHTML={{ __html: t('missionPage.ourVisionPart1') }} />
                      <p className="mt-4" dangerouslySetInnerHTML={{ __html: t('missionPage.ourVisionPart2') }} />

                      <h2 className="text-2xl font-semibold mb-4 mt-8">{t('missionPage.whyGreatThinkersTitle')}</h2>
                      <p className="mt-4" dangerouslySetInnerHTML={{ __html: t('missionPage.whyGreatThinkersPart1') }} />

                      <h2 className="text-2xl font-semibold mb-4 mt-8">{t('missionPage.technologyForHumanismTitle')}</h2>
                      <p className="mt-4">{t('missionPage.technologyForHumanismPart1')}</p>
                      <p className="mt-4" dangerouslySetInnerHTML={{ __html: t('missionPage.technologyForHumanismPart2') }} />

                      <h2 className="text-2xl font-semibold mb-4 mt-8">{t('missionPage.ourCommitmentTitle')}</h2>
                      <p className="mt-4">{t('missionPage.ourCommitmentIntro')}</p>
                      <ul>
                          <li>- {t('missionPage.ourCommitmentPoint1')}</li>
                          <li>- {t('missionPage.ourCommitmentPoint2')}</li>
                          <li>- {t('missionPage.ourCommitmentPoint3')}</li>
                      </ul>
                  </div>
              </div>
          </article>
      </div>

  );
}

export default MissionPage;
